import { Application } from 'jamespot-front-business';

import { useIntl } from 'react-intl';
import styled, { useTheme } from 'styled-components';

import { commonComponentsRegistry } from '../../registry/CommonRegistry';
import { useAppSelector } from '../../redux/store';

const AppsDropdownItem = styled.li`
    list-style: none;
`;

const AppsDropdownItemLink = styled.a`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.space.sm}px;
    text-decoration: none;
    color: ${({ theme }) => theme.font.color};
    padding: ${({ theme }) => theme.space.sm}px ${({ theme }) => theme.space.md}px ${({ theme }) => theme.space.sm}px
        ${({ theme }) => theme.space.xs}px;
    border-radius: ${({ theme }) => theme.size.sm}px;

    &:hover {
        text-decoration: none;
        background-color: ${({ theme }) => theme.color.grey1};
        color: ${({ theme }) => theme.font.color};
    }
`;

const Icon = commonComponentsRegistry.getLazyComponent('Icon');
const FlexBox = commonComponentsRegistry.getLazyComponent('FlexBox');
const Typography = commonComponentsRegistry.getLazyComponent('Typography');
const DropDown = commonComponentsRegistry.getLazyComponent('DropDown');

export const CalendarHeader = () => {
    const theme = useTheme();
    const intl = useIntl();
    const animatedMeeting = useAppSelector((state) => Application.selectors.selectById(state, 'AnimatedMeetingHook'));
    const calendarApp = useAppSelector((state) => Application.selectors.selectById(state, 'calendar'));
    const surveyDate = useAppSelector((state) => Application.selectors.selectById(state, 'SurveyDateHook'));

    if (!calendarApp) {
        return null;
    }

    return (
        <FlexBox y={'center'}>
            <Icon name={'icon-' + calendarApp.icon} variant="circle" color={calendarApp.color} size={40} />
            <Typography variant="h1" size="xl" weight="medium">
                {calendarApp.label}
            </Typography>
            {(surveyDate || animatedMeeting) && (
                <>
                    <Typography size="xl" color={'grey4'}>
                        /
                    </Typography>
                    <DropDown
                        withBorder
                        borderColor={'grey3'}
                        trigger={
                            <FlexBox y={'center'} gap={theme.space.xs}>
                                <Typography size="xl" color={'grey4'}>
                                    {intl.formatMessage({ id: 'CALENDAR_Agenda' })}
                                </Typography>
                                <Icon name={'icon-chevron-down'} color={'grey4'} size={16} />
                            </FlexBox>
                        }
                        dropdown={() => (
                            <FlexBox direction={'column'} gap={theme.space.sm} as={'ul'}>
                                {surveyDate && (
                                    <AppsDropdownItem>
                                        <AppsDropdownItemLink href={surveyDate.url}>
                                            <Icon
                                                name={'icon-' + surveyDate.icon}
                                                size={25}
                                                variant={'circle'}
                                                color={surveyDate.color}
                                            />
                                            <Typography size="l">{surveyDate.label}</Typography>
                                        </AppsDropdownItemLink>
                                    </AppsDropdownItem>
                                )}
                                {animatedMeeting && (
                                    <AppsDropdownItem>
                                        <AppsDropdownItemLink href={animatedMeeting.url}>
                                            <Icon
                                                name={'icon-' + animatedMeeting.icon}
                                                size={25}
                                                variant={'circle'}
                                                color={animatedMeeting.color}
                                            />
                                            <Typography size="l">{animatedMeeting.label}</Typography>
                                        </AppsDropdownItemLink>
                                    </AppsDropdownItem>
                                )}
                            </FlexBox>
                        )}
                    />
                </>
            )}
        </FlexBox>
    );
};
